/**
 * Universal Iframe Lazy Loader
 * Only lazy loads Universal iframe blocks, NOT modal overlays
 */

(function() {
  'use strict';

  function init() {
    setTimeout(() => {
      // ONLY find Universal iframe blocks, exclude modal overlays
      const allElements = document.querySelectorAll('[class*="ai-universal-iframe-"][data-block-id]');
      const elements = Array.from(allElements).filter(el => {
        // Exclude if inside a modal/overlay
        return !el.closest('[class*="modal"]') && !el.closest('[class*="overlay"]');
      });
      
      console.log(`[Lazy Loader] Found ${elements.length} Universal iframe blocks (excluding modals)`);

      // Delay loading for iframes 2+
      for (let i = 1; i < elements.length; i++) {
        delayIframeLoad(elements[i], i);
      }
    }, 100);
  }

  function delayIframeLoad(element, index) {
    const iframe = element.querySelector('iframe');
    if (!iframe) {
      console.warn(`[Lazy Loader] No iframe found in block ${index + 1}`);
      return;
    }

    console.log(`[Lazy Loader] Setting up lazy load for iframe ${index + 1}`);

    const desktopUrl = element.dataset.desktopUrl;
    const tabletUrl = element.dataset.tabletUrl;
    const mobileUrl = element.dataset.mobileUrl;
    const blockId = element.dataset.blockId;

    // Remove src to prevent loading
    if (iframe.src) {
      console.log(`[Lazy Loader] Removing src from iframe ${index + 1}`);
      iframe.removeAttribute('src');
    }

    // Observe when it comes into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log(`[Lazy Loader] Loading iframe ${index + 1}`);
          
          const isMobile = window.innerWidth < 750;
          const isTablet = window.innerWidth >= 750 && window.innerWidth < 1400;
          
          let url;
          if (isMobile && mobileUrl) url = mobileUrl;
          else if (isTablet && tabletUrl) url = tabletUrl;
          else url = desktopUrl;
          
          if (url) {
            const separator = url.includes('?') ? '&' : '?';
            iframe.src = url + separator + 'block_id=' + blockId;
          }
          
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '200px',
      threshold: 0
    });

    observer.observe(element);
    console.log(`[Lazy Loader] Now observing iframe ${index + 1}`);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
